import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "align-center",
  "use": "align-center-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"align-center\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m12 0h-12\" transform=\"translate(6 10)\" /><path d=\"m18 0h-18\" transform=\"translate(3 6)\" /><path d=\"m18 0h-18\" transform=\"translate(3 14)\" /><path d=\"m12 0h-12\" transform=\"translate(6 18)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol